import { BubbleLoading } from '@app/components/BubbleList/loading';
import { LoadingBoundary } from '@app/pages/i/components/LoadingBoundary';
import { Carousel, constants, Slide } from '@redbubble/design-system';
import { useViewportWidth } from '@redbubble/next/hooks';
import { AppProps, DeviceType } from '@redbubble/next/types';
import {
  AnalyticsContextTypes,
  AnalyticsStorage,
  AnalyticsStorageKeys,
} from '@redbubble/next-analytics/gtm';
import { usePageProps } from '@redbubble/next-provider';
import { kebabCase } from 'lodash';
import { BubbleItem } from 'types/shop-bff/types';
import { Bubble } from './Bubble';

export interface BubbleListProps {
  bubbles: BubbleItem[];
  event?: (urlPath: string) => void;
  seoVisible?: boolean;
}

const handleClick =
  (
    bubble: BubbleItem,
    event: BubbleListProps['event'],
    position: number,
    seoVisible?: boolean
  ) =>
  (clickEvent?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (seoVisible && clickEvent) clickEvent.preventDefault();
    AnalyticsStorage.setValue(
      AnalyticsStorageKeys.RefContextType,
      AnalyticsContextTypes.TopicPill
    );
    AnalyticsStorage.setValue(
      AnalyticsStorageKeys.RefContextIndex,
      `${position}`
    );
    AnalyticsStorage.setValue(
      AnalyticsStorageKeys.RefContextLabel,
      bubble.title
    );

    if (event) event(bubble.url);
    window.location.assign(bubble.url);
  };

export const BubbleList: React.FC<BubbleListProps> = ({
  bubbles,
  event,
  seoVisible,
}) => {
  const { deviceType } = usePageProps<AppProps>();
  const { isOrAbove } = useViewportWidth(deviceType);
  const isDesktop = isOrAbove(DeviceType.Desktop);

  return (
    <Carousel
      profile={isDesktop ? constants.DESKTOP : constants.MOBILE}
      slidesPerView="auto"
    >
      {bubbles.map((bubble, index) => (
        <Slide
          key={bubble.title}
          style={{ marginRight: '-8px' }}
          data-testid={`${kebabCase(bubble.title)}-bubble`}
        >
          <LoadingBoundary loadingComponent={<BubbleLoading />}>
            <Bubble
              title={bubble.title}
              onClick={handleClick(bubble, event, index, seoVisible)}
              href={seoVisible ? bubble.url : undefined}
              element="a"
            />
          </LoadingBoundary>
        </Slide>
      ))}
    </Carousel>
  );
};
